import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "areaSources",
    defaultRoutePath: "/commercials/areaSource",
    menuItemScope: "operations",
    menuItemName: "areaSource",

    routes: [
        {
            path: "/commercials/areaSource",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
